import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _60a55569 = () => interopDefault(import('../pages/401/index.vue' /* webpackChunkName: "pages/401/index" */))
const _1606a5f6 = () => interopDefault(import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _1b91dc6d = () => interopDefault(import('../pages/forbidden/index.vue' /* webpackChunkName: "pages/forbidden/index" */))
const _afcecb7a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _731b7d58 = () => interopDefault(import('../pages/sites/_sid/index.vue' /* webpackChunkName: "pages/sites/_sid/index" */))
const _2181ba2b = () => interopDefault(import('../pages/preview/_sid/_pageid/_langid/index.vue' /* webpackChunkName: "pages/preview/_sid/_pageid/_langid/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/401",
    component: _60a55569,
    name: "401"
  }, {
    path: "/demo",
    component: _1606a5f6,
    name: "demo"
  }, {
    path: "/forbidden",
    component: _1b91dc6d,
    name: "forbidden"
  }, {
    path: "/",
    component: _afcecb7a,
    name: "index"
  }, {
    path: "/sites/:sid",
    component: _731b7d58,
    name: "sites-sid"
  }, {
    path: "/preview/:sid?/:pageid?/:langid",
    component: _2181ba2b,
    name: "preview-sid-pageid-langid"
  }, {
    path: "/:lang/",
    component: _afcecb7a,
    props: true,
    name: "SiteLangIndexPage"
  }, {
    path: "/:lang/:pageid",
    component: _afcecb7a,
    props: true,
    name: "SiteLangPagePage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
